import { FC } from 'react';

import { Box, Image, Link, Text } from '@bonusly/design-system';

import { isIOSDevice } from '../../../../../utils/browser';
import { GenericAttachment } from '../../types/generic-attachment';

type EmployeeSpotlightAttachmentProps = {
	attachment: GenericAttachment;
};

export const EmployeeSpotlightAttachment: FC<EmployeeSpotlightAttachmentProps> = ({ attachment }) => {
	if (!attachment.url || !attachment.image_url) {
		return null;
	}

	const aspectRatio = attachment.width != null && attachment.height != null ? `${attachment.width} / ${attachment.height}` : undefined;

	// iOS webviews behave poorly with target="_blank" - causes tab jump and back navigation
	const linkTarget = isIOSDevice() ? undefined : '_blank';

	return (
		<Link href={attachment.url} target={linkTarget} data-testid="employee-spotlight-link" _hover={{ textDecoration: 'none' }}>
			<Box
				bg="bg.surface"
				borderRadius="lg"
				border="1px solid"
				borderColor="border.default"
				overflow="hidden"
				p={3}
				pb={4}
				data-testid="employee-spotlight-frame"
			>
				<Image src={attachment.image_url} width="100%" aspectRatio={aspectRatio} borderRadius="md" data-testid="employee-spotlight-image" />
				{attachment.title && (
					<Text mt={4} fontWeight="semibold" fontSize="md" color="text.default" data-testid="employee-spotlight-title">
						{attachment.title}
					</Text>
				)}
			</Box>
		</Link>
	);
};
